import { render, staticRenderFns } from "./companySetting.vue?vue&type=template&id=4e5d36d7&scoped=true"
import script from "./companySetting.vue?vue&type=script&lang=js"
export * from "./companySetting.vue?vue&type=script&lang=js"
import style0 from "./companySetting.vue?vue&type=style&index=0&id=4e5d36d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d36d7",
  null
  
)

export default component.exports